export class PreloadImages {

    constructor() {

    }

    static preload() {
        const placeholder = "/App_Firma/img/default.jpg";
        const imagesWithoutLazyload = [...document.getElementsByClassName("js_preload")];

        imagesWithoutLazyload.forEach(image => {
            image.src = image.getAttribute('data-src');
            image.addEventListener('error', () => {

                if (!image.classList.contains('loading-error')) {
                    image.src = placeholder;
                    image.classList.add('loading-error');
                }
            });

            const { src } = image;
            image.removeAttribute('src');
            image.src = src;

        });
    }

    static checkImage() {
        const placeholder = "/App_Firma/img/default.jpg";
        let img = new Image();
        img.onload = function(){
            return url;
        };
        img.onerror = function(){
            return placeholder;
        };
        img.src = url;
        return placeholder;
    }
}